module.exports = __webpack_public_path__ + "img/CCLF_infographic-13.5be96db5.png";